import BaseService from "./BaseService";

const API_SIDEBAR_NAVIGATION = `${process.env.VUE_APP_BACKEND_API}/SideBarNavigation`;

class UIService extends BaseService
{
    /**
     * Get the sidebar navigation.
     * 
     * @return {Promise}
     */
    static getSidebarNavigation()
    {
        if(!this.hasSession())
            return Promise.reject();

        return window.axios.get(API_SIDEBAR_NAVIGATION);
    }
}

export default UIService;
